/**
 * `timeline` — monday's `TimelineBoardView` (`specs/M4-V5-timeline.md`).
 *
 * monday's Timeline and Gantt are **one component**: both mount `.react-timeline-container` and
 * both store the identical nine `settings_str` keys; the API tells them apart only by
 * `BoardView.type`, and the UI only by a 232 px side panel instead of 416 and a missing
 * *Baseline* button `[cap:views/INDEX.md]`. So the settings type is the Gantt's, aliased rather
 * than copied — a future divergence gets a seam here and today's duplication is zero.
 *
 * The one real difference in the stored data: a new Timeline opens at **Days**, which is what
 * `prod-timeline` is stored at, against the Gantt's Quarters.
 */
import { defineViewType, normaliseOverDefaults } from '../types.js';
import { mondayShapedSettings } from '../from-monday.js';
import { DEFAULT_GANTT_VIEW_SETTINGS, ganttSettingsFromMonday, ganttSettingsToMonday, ganttViewSettingsSchema, } from '../gantt/index.js';
export const timelineViewSettingsSchema = ganttViewSettingsSchema;
export const DEFAULT_TIMELINE_VIEW_SETTINGS = {
    ...DEFAULT_GANTT_VIEW_SETTINGS,
    zoom: 'days',
};
export function timelineSettingsFromMonday(raw) {
    return ganttSettingsFromMonday(raw, { kind: 'timeline', defaults: DEFAULT_TIMELINE_VIEW_SETTINGS });
}
export function timelineSettingsToMonday(settings) {
    return ganttSettingsToMonday(settings, { defaults: DEFAULT_TIMELINE_VIEW_SETTINGS });
}
/** The Gantt metrics with the two chrome differences applied (`[V5§2.1]`). */
export const TIMELINE_METRICS = {
    sidePanelWidth: 232,
    showBaseline: false,
    /** The Gantt's side panel prints the item's date range in a second column; the Timeline's does not. */
    sidePanelDates: false,
};
export const timelineView = defineViewType({
    id: 'timeline',
    title: 'Timeline',
    mondayViewType: 'TimelineBoardView',
    kind: 'APP',
    settingsSchema: timelineViewSettingsSchema,
    defaultSettings: DEFAULT_TIMELINE_VIEW_SETTINGS,
    normaliseSettings: (input) => normaliseOverDefaults('timeline', timelineViewSettingsSchema, DEFAULT_TIMELINE_VIEW_SETTINGS, mondayShapedSettings(input, DEFAULT_TIMELINE_VIEW_SETTINGS, timelineSettingsFromMonday)),
    requiredColumnTypes: [],
    supportsFilters: true,
    supportsSort: true,
    supportsGroupBy: true,
    canBeDefault: true,
    implemented: true,
    plannedIn: null,
    /** monday keeps Timeline in *Explore more views*, not the first section (`[V1§2.5]`). */
    gallery: { order: 11, section: 'explore' },
});
//# sourceMappingURL=index.js.map